exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#carousel {\n  margin-left: -7vw;\n  width: 100vw;\n  margin-top: 69px;\n}\n#carousel .carousel-big-screen {\n    display: block;\n}\n#carousel .carousel-small-screen {\n    display: none;\n}\n@media screen and (max-width: 660px) {\n#carousel {\n    margin-left: 0;\n}\n#carousel .carousel-big-screen {\n      display: none;\n}\n#carousel .carousel-small-screen {\n      display: block;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7aac179b","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/global/carousel/carousel.component.scss
// module id = 230
// module chunks = 1